<template>
  <div :id="id">
    <b-form-group>
      <div class="fake-form-control">
        <div class="d-flex justify-content-between align-items-center w-100">
          <div class="geos">
            <span class="geo" v-for="g in value" :key="g">
              <b-badge variant="secondary">
                {{ codeToName(g) }}
              </b-badge>
            </span>
            <span v-if="value.length === 0" class="text-muted">All locations</span>
          </div>
          <div class="edit-geos-button ml-auto">
            <b-button size="" variant="primary" @click.stop="openEditor">
              <font-awesome-icon icon="pen"/>
              <span>Edit</span>
            </b-button>
          </div>
        </div>
      </div>
    </b-form-group>

    <GeoEditor
      :modal-id="modalId"
      :title="title"
      :geos="allGeos"
      :value="value"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import GeoEditor from "./GeoEditor.vue"

export default {
  name: 'Geos',

  components: {
    GeoEditor
  },

  data: function() {
    return {
      allGeos: []
    };
  },

  props: {
    id: String,
    url: String,
    value: Array,
    title: { type: String, default: "Edit Geo" }
  },

  computed: {
    modalId() {
      return `geo-editor-${this.id}`
    }
  },

  methods: {
    openEditor() {
      this.$bvModal.show(this.modalId)
    },

    codeToName(code) {
      for(var i = 0; i < this.allGeos.length; ++i) {
        if(this.allGeos[i].code == code) return this.allGeos[i].name
      }

      return code;
    },

    getGeos() {
      fetch(this.url)
      .then(function(resp) {
        return resp.json();
      })
      .then(resp => {
        this.allGeos = resp.data;
      });
    }
  },

  created() {
    this.getGeos()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .geo {
    margin-left: 4px;
    margin-bottom: 2px;
    display: inline-block;
  }

  .geos {
    text-align: left;
  }

  // Make the button small and fit well
  .edit-geos-button {
      .btn {
          padding: 2px 8px;
          font-size: 0.7rem;
      }
  }

</style>
